// GTM Analytics Event Helpers
// All GTM-related event push helpers live here.

/**
 * Track an Explore search event in GTM.
 * @param {Object} params
 * @param {Object} params.area - The selected area object (should include slug and name fields)
 * @param {Object} params.pack - The selected pack object (should include slug and name fields)
 * @param {Array} params.tags - Array of selected tag objects (each should include slug and name fields)
 * @param {string} [params.language] - (Optional) Current language code
 */
export function trackExplore({ area, pack, tags, language }) {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'explore_search',
        area_id: area.slug,
        area_name: area.name, // Pass display name in current language if possible
        pack_id: pack.slug,
        pack_name: pack.name,
        tag_ids: tags.map(t => t.slug),
        tag_names: tags.map(t => t.name),
        language: language || undefined,
    });
} 